import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { Check, X } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useShop } from '@/components/providers/shop-provider'

export const ShopToaster: FC = (): ReactNode => {
    const { toast, dismissToast, openCart } = useShop()

    return (
        <div aria-live='polite' className='pointer-events-none fixed inset-x-0 bottom-4 z-[95] flex justify-center px-4 sm:bottom-6 sm:justify-end sm:px-6'>
            <div
                key={toast?.id}
                className={cn(
                    'pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-3xl border border-white/70 bg-cream-50/95 p-3 pr-2 shadow-[0_24px_60px_-24px_rgba(58,40,30,0.55)] backdrop-blur-xl transition-all duration-300',
                    toast ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'
                )}
            >
                {toast && (
                    <>
                        <span className='grid size-10 shrink-0 place-items-center rounded-full bg-sage-100 text-sage-700'>
                            <Check className='size-5' />
                        </span>
                        <div className='min-w-0 flex-1'>
                            <p className='text-sm font-semibold text-cocoa-900'>
                                {toast.title}
                            </p>
                            {toast.product && (
                                <p className='truncate text-xs text-muted-foreground'>
                                    <span data-mdlfy-cms={`products:${toast.product.id}:name`}>
                                        {toast.product.name}
                                    </span>
                                    {toast.detail && <span>, {toast.detail}</span>}
                                </p>
                            )}
                            {!toast.product && toast.detail && (
                                <p className='text-xs text-muted-foreground'>
                                    {toast.detail}
                                </p>
                            )}
                        </div>
                        {toast.action === 'cart' && (
                            <button
                                type='button'
                                onClick={() => {
                                    dismissToast()
                                    openCart()
                                }}
                                className='shrink-0 rounded-full bg-cocoa-800 px-3.5 py-2 text-xs font-semibold text-cream-50 transition hover:bg-cocoa-700'
                            >
                                Lihat keranjang
                            </button>
                        )}
                        {toast.action === 'wishlist' && (
                            <Link
                                href='/wishlist'
                                onClick={dismissToast}
                                className='shrink-0 rounded-full bg-cocoa-800 px-3.5 py-2 text-xs font-semibold text-cream-50 transition hover:bg-cocoa-700'
                            >
                                Lihat
                            </Link>
                        )}
                        <button
                            type='button'
                            onClick={dismissToast}
                            aria-label='Tutup'
                            className='grid size-8 shrink-0 place-items-center rounded-full text-cocoa-500 hover:bg-muted'
                        >
                            <X className='size-4' />
                        </button>
                    </>
                )}
            </div>
        </div>
    )
}
